import element from "./element/hi";
import { welcome_tour_hi } from "./welcome-tour";
import { notificationHindi } from "./notification";
import { sequence_hindi } from "./sequence/zh-tw";
import base from "./base/hi";
import search from "./search/hi";
import services from "./services/hi";
import intent from "./intent/hi";
import { tableEmptyInformationHindi } from "./common/table-empty-infomation/zh-tw";
import { globalMessageHindi } from "./common/global-message/zh-tw";
import { settingApiKeysHindi } from "./settings/api-keys/zh-tw";
import { settings_pricing_hindi } from "./settings/pricing/zh-tw";
import home from "./home/hi";
import premium from "./premium/hi";
import business from "./bussiness/hi";
import filter from "./filter/hi";
import { monitors_hi } from "./monitors";
import { enrich_hi } from "./enrich";
import popup from "./popup/hi";
import { settings_role_team_hindi } from "./settings/role-teams";
import { settings_pricing_plan_hi } from "./settings/pricing-plan";
import { settings_profile_organization_hi } from "./settings/profile-organization";
import { settings_users_hi } from "./settings/users";
import { settings_custom_field_hindi } from "./settings/custom-field";
import { settings_billing_hindi } from "./settings/billing/zh-tw";

import { settings_redeem_code_hi } from "./settings/redeem-code";
import { settings_plan_usage_hi } from "./settings/plan-usage";
import { settings_referral_hi } from "./settings/referal";

export default {
  //login
  loading: "लोड हो रहा है...",
  SignUp: "साइन अप करें",
  LoginSuccess: "सफलतापूर्वक लॉग इन किया गया",
  LoginOut: "सफलतापूर्वक लॉग आउट किया गया",
  email: "ईमेल",
  password: "पासवर्ड",
  logIn: "लॉग इन करें",
  WelcomeBack: "वापसी पर स्वागत है",
  PleaseEnterYourEmailAndPassword: "कृपया अपना ईमेल और पासवर्ड दर्ज करें",
  CharactersRequired: "8+ वर्ण आवश्यक हैं",
  keepMeSignedIn: "मुझे लॉग इन रखें",
  forgetPassword: "पासवर्ड भूल गए",
  dontHaveAnAccount: "खाता नहीं है? ",
  signUpNow: "अभी साइन अप करें",
  AllRightsReserved: "सभी अधिकार सुरक्षित",
  privacyPolicy: "गोपनीयता नीति",
  and: "और",
  termsOfService: "सेवा की शर्तें",
  Name: "नाम",
  viewAll: "सभी देखें",
  fold: "मोड़",
  updateCreditCard: "क्रेडिट कार्ड अपडेट करें",
  role: "भूमिका",
  noLimit: "कोई सीमा नहीं",

  //signup
  company: "कंपनी",
  companyName: "कंपनी का नाम",
  signUp: "साइन अप करें",
  alreadyHaveAnAccount: "पहले से ही एक खाता है? ",
  getStarted: "शुरू करें! हमारे प्लेटफॉर्म के साथ अपने व्यवसाय को सशक्त करें",
  signUpSuccess: "सफलतापूर्वक साइन अप किया गया",

  //foget
  noWorries:
    "चिंता न करें, अपना पंजीकृत ईमेल दर्ज करें, और हम आपको रीसेट निर्देश भेजेंगे",

  //reset
  reset: "रीसेट करें",
  forgotPassword: "पासवर्ड भूल गए",
  RequestPasswordReset: "पासवर्ड रीसेट का अनुरोध करें",
  backToLogin: "लॉगिन पर वापस जाएं",
  signInToCommandCenter: "अपने कमांड सेंटर में साइन इन करें",
  signInSubcopy: "जहाँ छोड़ा था वहीं से शुरू करें — हर कंपनी की हलचल आपका इंतज़ार कर रही है।",
  createYourAccount: "बाज़ार की हलचल पर नज़र रखना शुरू करें",
  signUpSubcopy: "अपना खाता बनाएं और देखें कि कौन-सी कंपनियाँ नए बाज़ारों में प्रवेश कर रही हैं — आपके प्रतिस्पर्धियों से पहले।",
  getStartedShort: "शुरू करें",
  accountRecovery: "खाता पुनर्प्राप्ति",
  resetPasswordTitle: "नया पासवर्ड सेट करें",
  secureYourAccount: "अपना खाता सुरक्षित करें",
  authBoard: {
    title: "आपका बोर्ड, रीयल-टाइम में सक्रिय।",
    sub: "जब भी कोई कंपनी नए बाज़ार में प्रवेश करती है — उसी दिन, प्रमाण के साथ यहाँ दिखता है।",
    live: "लाइव · वैश्विक हलचल",
    updating: "स्वतः अपडेट हो रहा है",
    moves: "हाल की हलचलें",
    corridors: "सक्रिय गलियारे",
    newMarket: "नया बाज़ार",
    backedBy: "Hub71 द्वारा समर्थित",
    tracked: "80 करोड़+ कंपनियाँ ट्रैक",
    countries: "30 देश",
    source: {
      ads: "विज्ञापन इंटेलिजेंस",
      news: "समाचार",
      linkedin: "LinkedIn",
      jobs: "नौकरी पोस्टिंग",
      press: "प्रेस",
      default: "कई स्रोत",
    },
  },
  verifyPassword: "पासवर्ड सत्यापित करें",
  EnterANewPasswordFor: "उदाहरण@gmail.com के लिए एक नया पासवर्ड दर्ज करें",
  ResetPassword: "पासवर्ड रीसेट करें",
  newPassword: "नया पासवर्ड",

  //account
  addCreditCard: "क्रेडिट कार्ड जोड़ें",
  zip: "ज़िप",
  country: "देश",
  state: "राज्य",
  city: "शहर",
  address: "पता",
  billingInformation: "बिलिंग जानकारी",
  yourTeams: "आपकी टीमें",
  cvc: "सीवीसी",
  year: "वर्ष",
  month: "माह",
  creditCardNumber: "क्रेडिट कार्ड नंबर",
  cardInformation: "कार्ड जानकारी",
  title: "शीर्षक",
  fullName: "पूरा नाम",
  yourDetail: "आपका विवरण",
  creditsToUse: "उपयोग करने के लिए क्रेडिट।",
  youHave: "आपके पास हैं",
  download: "डाउनलोड करें",
  buyMoreCredits: "अधिक क्रेडिट खरीदें",
  description: "विवरण",
  topUpCredits: "क्रेडिट टॉप अप करें",
  cancel: "रद्द करें",
  date: "तारीख",
  invoiceHistory: "चालान इतिहास",
  confirmNewPass: "नया पास पुष्टि करें",
  creditsUsed: "उपयोग किए गए क्रेडिट",
  newPass: "नया पास",
  oldPass: "पुराना पास",
  cardNumber: "कार्ड नंबर:",
  changePassword: "पासवर्ड बदलें",
  creditUsage: "क्रेडिट उपयोग",
  typeTheNewTitle: "नया शीर्षक टाइप करें",
  save: "सहेजें",
  addMoreCredits: "अधिक क्रेडिट जोड़ें",
  featureRequest: "सुविधा अनुरोध",
  creditsMo: "{credit} क्रेडिट / माह",
  apiIntegrations: "एपीआई एकीकरण",
  workspaceSubscription: "कार्यस्थान सदस्यता",
  "additional-user-licence": "अतिरिक्त उपयोगकर्ता लाइसेंस",
  "agency-white-label": "एजेंसी व्हाइट लेबल",
  "api-extended-limit": "एपीआई विस्तारित सीमा",
  "profile-subscription": "कार्यस्थान सदस्यता",
  creditsInYourPlan: "क्रेडिट (आपकी योजना में)",
  plugin: "प्लगइन",
  settings: "सेटिंग्स",
  phone: "फ़ोन",
  "1User": "1 उपयोगकर्ता",
  users: "उपयोगकर्ता",
  billing: "बिलिंग",
  monthlyQueryLimit: "मासिक क्वेरी सीमा",
  price: "कीमत",
  whatsIncluded: "क्या शामिल है",
  givenName: "दिया गया नाम",
  profile_teams: "प्रोफ़ाइल और टीमें",
  purchasePlan: "योजना खरीदें",
  accountOverview: "खाता अवलोकन",
  familyName: "पारिवारिक नाम",
  dailyQueryLimit: "दैनिक क्वेरी सीमा",
  rateLimit: "दर सीमा",
  youAreOnA: "आप एक",
  PlanAndYourCreditsWillRefreshOn:
    "योजना पर हैं और आपके क्रेडिट इस दिन ताज़ा होंगे",
  过期: "",
  searchSettings: "सेटिंग्स खोजें...",
  plan: "योजना",
  accountInfo: "खाता जानकारी",
  creditCardInformation: "क्रेडिट कार्ड जानकारी",
  apiUsage: "एपीआई उपयोग",
  mo: "/माह",
  perUserPerMonth: "प्रति उपयोगकर्ता प्रति माह",
  billedAnnually: "सालाना बिल किया गया",
  dailyQuery: "दैनिक क्वेरी",
  monthlyQuery: "मासिक क्वेरी",
  currentPlan: "वर्तमान योजना",
  everythingInPlus: "प्लस में सब कुछ",
  addCredits: "क्रेडिट जोड़ें",
  allPlansInclude: "सभी योजनाओं में शामिल हैं",
  Amount: "राशि",
  credits: "क्रेडिट",
  purchaseSuccess: "क्रेडिट सफलतापूर्वक खरीदा गया, आपके कुल क्रेडिट हैं",
  Loading: "लोड हो रहा है",
  Selected: "चयनित",
  SelectPlan: "योजना चुनें",
  learnAboutTopupCredits: "टॉप अप क्रेडिट के बारे में जानें",
  currentPlan: "वर्तमान सदस्यता",
  upgradeSuccess: "योजना सफलतापूर्वक स्विच की गई",
  purchaseFailed: "खरीद विफल रही",
  upgradeFailed: "योजना स्विच विफल रही",
  inviteSentSuccessfully: "आमंत्रण सफलतापूर्वक भेजा गया",
  DeleteSuccessfully: "सफलतापूर्वक हटाया गया",
  AccountupdatedSuccessfully: "खाता सफलतापूर्वक अपडेट किया गया",
  AccountUpdateFailed: "खाता अपडेट विफल रहा",
  PasswordUpdatedSuccessfully: "पासवर्ड सफलतापूर्वक अपडेट किया गया",
  PasswordUpdateFailed: "पासवर्ड अपडेट विफल रहा",
  teamDetails: "कार्यस्थान विवरण",
  teamName: "कार्यस्थान का नाम",
  changeTeam: "कार्यस्थान बदलें",
  clickToChangeTeam: "कार्यस्थान बदलने के लिए क्लिक करें",
  changeTeamSuccessfully: "कार्यस्थान सफलतापूर्वक बदल दिया गया",
  status: "स्थिति",
  Action: "कार्रवाई",
  pending: "लंबित",
  current: "वर्तमान",
  AreYouSureYouWantToDeleteThisTeamMember:
    "क्या आप वाकई इस कार्यस्थान सदस्य को हटाना चाहते हैं?",
  PasswordCannotBeEmpty: "पासवर्ड खाली नहीं हो सकता",
  newUser: "नया उपयोगकर्ता",
  deleteUser: "उपयोगकर्ता हटाएँ",
  nickname: "उपनाम",
  admin: "व्यवस्थापक",
  inviteYourTeam: "अपने कार्यस्थान के सदस्यों को आमंत्रित करें",
  empowerEveryoneToGetMoreDealsDonefaster:
    "सभी को अधिक सौदों को तेज़ी से पूरा करने के लिए सशक्त करें",
  addMultipleEmailAddressesSeparatedByCommas:
    "कॉमा द्वारा अलग किए गए कई ईमेल पते जोड़ें",
  sendInvites: "आमंत्रण भेजें",
  FirstName: "पहला नाम",
  LastName: "अंतिम नाम",
  timezone: "समय क्षेत्र",
  contactNo: "संपर्क नंबर",
  controlYourTeamMembersAndTheirAccountAccessRightHere:
    "अपने कार्यस्थान के सदस्यों और उनके खाते तक पहुंच को यहीं नियंत्रित करें।",
  pleaseEnterYourCurrentPasswordToChangeYourPassword:
    "कृपया अपना पासवर्ड बदलने के लिए अपना वर्तमान पासवर्ड दर्ज करें।",
  updatePassword: "पासवर्ड अपडेट करें",
  oldPassword: "पुराना पासवर्ड",
  confirmNewPassword: "नया पासवर्ड पुष्टि करें",
  empowerEveryoneToGetMoreDealsDoneFaster:
    "सभी को अधिक सौदों को तेज़ी से पूरा करने के लिए सशक्त करें।",
  enterEmailAddressesMultipleCommaseparated: "ईमेल पते दर्ज करें (कई कॉमा-अलग)",
  invoice: "चालान",
  accountAdmin: "खाता व्यवस्थापक",
  setAsDefault: "डिफ़ॉल्ट के रूप में सेट करें",
  bankName: "बैंक का नाम",
  expiry: "समाप्ति",
  viewAllYourPreviousInvoicesHere: "यहां अपने सभी पिछले चालान देखें।",
  BillingHistory: "बिलिंग इतिहास",
  updateYourCreditCardInformation: "अपनी क्रेडिट कार्ड जानकारी अपडेट करें।",
  ManageCreditCard: "क्रेडिट कार्ड प्रबंधित करें",
  CardNumber: "कार्ड नंबर",
  billingAddress: "बिलिंग पता",
  yourCreditsWillRefreshOn: "आपके क्रेडिट इस दिन ताज़ा होंगे",
  plan_prepaid_notice: "{date} तक प्रीपेड — तब तक नवीनीकरण शुल्क नहीं लिया जाएगा।",
  yourCreditsWillBeChargeOn: "आपके क्रेडिट इस दिन चार्ज किए जाएंगे",
  被收取: "",
  perYear: "/वर्ष",
  perMonth: "/माह",
  monthlyCredit: "मासिक क्रेडिट",
  Usage: "उपयोग",
  features: "विशेषताएँ",
  credits_mo: "क्रेडिट/माह",
  credits_year: "क्रेडिट/वर्ष",
  _mo: "/माह",
  Quantity: "मात्रा",
  seeOtherPlan: "अन्य योजनाएं देखें",
  subscriptionTiers: "सदस्यता स्तर",
  experiencePricingThatsEasyToUnderstandAndAdaptable:
    "मूल्य निर्धारण का अनुभव करें जो समझने में आसान और आपकी आवश्यकताओं के अनुकूल हो।",
  monthlyBilling: "मासिक बिलिंग",
  annualBilling: "सालाना बिलिंग",
  forPlanCustomizationContactOurSalesTeam:
    "योजना अनुकूलन के लिए, हमारी बिक्री टीम से संपर्क करें",
  billedAnnually_user: "सालाना बिल किया गया/उपयोगकर्ता",
  seePlanComparison: "योजना तुलना देखें",
  topUp: "टॉप अप",
  changeTeamNameFailed: "टीम का नाम बदलना विफल रहा",

  // purchaseCreditsAtTheRateOf100PerCreditCustomize: 'Purchase credits at the rate of $1.00 per credit. Customize your credit bundle based on your needs. ',
  totalPrice: "कुल कीमत",
  credit: "क्रेडिट",
  collapse: "ढहाएँ",
  expand: "विस्तार करें",

  // analytic
  showNumber: "संख्या दिखाएँ",
  Website: "वेबसाइट",
  b2bTraffic: "बी2बी ट्रैफ़िक",
  b2bReturningVsNew: "बी2बी वापस आने वाले बनाम नए आगंतुक",
  visitors: "आगंतुक",
  totalView: "कुल दृश्य",
  totalSessions: "कुल सत्र",
  operatingSystem: "ऑपरेटिंग सिस्टम",
  browser: "ब्राउज़र",
  device: "डिवाइस",
  companySize: "कंपनी का आकार",
  topIndustry: "शीर्ष उद्योग",
  topCountries: "शीर्ष देश",
  topReferrals: "शीर्ष रेफरल",
  new: "नया",
  returning: "वापस आने वाले",
  countriesStatistics: "देशों के आँकड़े",
  topCompaigns: "शीर्ष अभियान",
  topPagesByVisits: "विज़िट के अनुसार शीर्ष पृष्ठ",
  topPagesByEngagement: "जुड़ाव के अनुसार शीर्ष पृष्ठ",
  Referrals: "रेफरल",
  Pages: "पृष्ठ",
  avgTime: "औसत समय",
  totalCompanies: "कुल कंपनियाँ",
  b2bPageViews: "बी2बी पेज व्यू",
  TotalSessions: "कुल सत्र",
  viewCompanyList: "कंपनियों की सूची देखें",
  noDiscussionsYet: "अभी तक कोई चर्चा नहीं हुई है",
  useThisSpaceToAskQuestions:
    "आप इस स्थान का उपयोग प्रश्न पूछने, अपडेट प्राप्त करने और सीधे हमारे साथ विवरण पर चर्चा करने के लिए कर सकते हैं",

  // market-intent
  comingSoon: "जल्द ही आ रहा है",
  pleaseEnterAValidSiteUrl: "कृपया एक मान्य साइट यूआरएल दर्ज करें",
  weAreCurrentlyWorkingOnThisFeature:
    "हम वर्तमान में इस सुविधा पर काम कर रहे हैं और जल्द ही इसे लॉन्च करेंगे",
  stayConnectedWithUs:
    "अपडेट प्राप्त करने के लिए हमारे सोशल मीडिया चैनलों के माध्यम से हमारे साथ जुड़े रहें।",
  selectAWebsite: "एक वेबसाइट चुनें",

  // sequence
  Sequences: "अनुक्रम",
  label: "लेबल",
  template: "टेम्पलेट",
  folder: "फ़ोल्डर",
  single: "एकल",
  group: "समूह",
  steps: "चरण",
  sizes: "आकार",
  time: "समय",
  //email
  SendATestEmail: "एक परीक्षण ईमेल भेजें",
  Categories: "श्रेणियाँ",
  addToCategory: "श्रेणी में जोड़ें",
  EnterOrCreateCategories: "श्रेणियां दर्ज करें या बनाएं",
  addSuccessfully: "सफलतापूर्वक जोड़ा गया",
  Channels: "चैनल",
  emails: "ईमेल",
  enterChannel: "चैनल दर्ज करें",
  CategoryName: "श्रेणी का नाम",
  PleaseEnterANewCategoryName: "कृपया एक नया श्रेणी नाम दर्ज करें:",
  EnterANewCategoryName: "एक नया श्रेणी नाम दर्ज करें",
  Steps: "चरण",
  Actions: "कार्य",
  Time: "समय",
  From: "से",
  To: "को",
  CancelSequenceCreation: "अनुक्रम निर्माण रद्द करें",
  AreYouSureYouWantToCancelTheSequenceCreationProcess:
    "क्या आप वाकई अनुक्रम निर्माण प्रक्रिया को रद्द करना चाहते हैं?",
  SaveAsDraft: "ड्राफ़्ट के रूप में सहेजें",
  CancelSequence: "अनुक्रम रद्द करें",
  ByCancelingAllSettingsWillBeLost:
    "रद्द करने से, आपके द्वारा की गई सभी सेटिंग्स और प्रगति खो जाएगी।",
  ReplyFields: "उत्तर फ़ील्ड",
  continue: "जारी रखें",
  Contacts: "संपर्क",
  Back: "पीछे",
  Import: "आयात करें",
  Imported: "आयात किया गया",
  Skipped: "छोड़ा गया",
  Done: "हो गया",
  NewCustomField: "नया कस्टम फ़ील्ड",
  EnterNewLabel: "नया लेबल दर्ज करें",
  EnterNewType: "नया प्रकार दर्ज करें",
  removeRecorded: "रिकॉर्ड किया गया हटाएँ",
  StayPage: "पृष्ठ पर रहें",
  LeavePage: "पृष्ठ छोड़ें",
  NewCategory: "नई श्रेणी",
  Create: "बनाएँ",
  UnlockingSequence: "इस अनुक्रम को अनलॉक करने से आप संशोधन कर सकते हैं",
  ModifyingLeadDeselection:
    "इस सामग्री को संशोधित करने से वर्तमान टेम्पलेट संस्करण का चयन रद्द हो जाएगा",
  Modify: "संशोधित करें",
  CancelingPreserveCurrent: "रद्द करने से वर्तमान संस्करण संरक्षित रहेगा",
  rename: "नाम बदलें",
  CreatNewLabel: "नया लेबल बनाएँ",
  NewLabel: "नया लेबल",
  PleaseEnterANewLabelName: "कृपया एक नया लेबल नाम दर्ज करें:",
  EnterANewLabelName: "एक नया लेबल नाम दर्ज करें",
  SequenceName: "अनुक्रम का नाम",
  PleaseProvideNameForNewSequence:
    "कृपया अपने नए अनुक्रम के लिए एक नाम प्रदान करें",
  EnterNewSequenceName: "नया अनुक्रम नाम दर्ज करें",
  SetUpEmail: "भेजने के लिए एक ईमेल खाता सेट करें",
  NewSchedule: "नया शेड्यूल",
  PleaseEnterANewScheduleName: "कृपया एक नया शेड्यूल नाम दर्ज करें:",
  EnterNewScheduleName: "एक नया शेड्यूल नाम दर्ज करें",
  AddNewTemplate: "नया टेम्पलेट जोड़ें",
  RemoveFromTemplate: "टेम्पलेट से हटाएँ",
  deleteSuccess: "सफलतापूर्वक हटाया गया",
  removeSuccess: "सफलतापूर्वक हटाया गया",
  GroupName: "समूह का नाम",
  PleaseEnterNewGroupName: "कृपया नया समूह नाम दर्ज करें",
  EnterNewGroupName: "नया समूह नाम दर्ज करें",
  TemplateName: "टेम्पलेट का नाम",
  PleaseEnterANewTemplateName: "कृपया एक नया टेम्पलेट नाम दर्ज करें",
  EnterNewTemplateName: "एक नया टेम्पलेट नाम दर्ज करें",
  renameSuccessfully: "सफलतापूर्वक नाम बदला गया",
  CreateSuccessfully: "सफलतापूर्वक बनाया गया",
  addToGroup: "समूह में जोड़ें",
  SelectChannelForNewTemplate: "नए टेम्पलेट के लिए चैनल चुनें",
  Role: "भूमिका",
  Account: "खाता",
  customFields: "कस्टम फ़ील्ड",
  contactsToStartEngagingWithThem: "संपर्कों से जुड़ना शुरू करने के लिए।",
  thisSequenceDoesntHaveAnyProspectsOrLeadsYetConsid:
    "इस अनुक्रम में अभी तक कोई संभावित ग्राहक या लीड नहीं है। जोड़ने पर विचार करें",
  noProspectsAdded: "कोई संभावित ग्राहक नहीं जोड़ा गया",
  deliveryCurrentlyNoMessagesHaveBeenSentThroughTheS:
    "डिलीवरी। वर्तमान में, अनुक्रम के माध्यम से कोई संदेश नहीं भेजा गया है।",
  ensureEfficientCommunicationByMonitoringYourSequen:
    "अपने अनुक्रम के संदेश की निगरानी करके कुशल संचार सुनिश्चित करें",
  noMessagesHaveBeenSent: "कोई संदेश नहीं भेजा गया है",
  yourNeedsGetStartedByClickingNewSequence:
    "आपकी ज़रूरतों के लिए। [+ नया अनुक्रम] पर क्लिक करके शुरू करें",
  beginBuildingYourSalesStrategiesByDesigningSequenc:
    "अपनी बिक्री रणनीतियों का निर्माण शुरू करें, जो अनुरूप अनुक्रमों को डिजाइन करके",
  noSequencesCreatedYet: "अभी तक कोई अनुक्रम नहीं बनाया गया है",
  leadActions: "लीड क्रियाएँ",
  leadInformation: "लीड जानकारी",
  thisGroupHasNoTemplatesYet: "इस समूह में अभी तक कोई टेम्पलेट नहीं है",
  key: "{expr}",
  copyContent: "सामग्री कॉपी करें",
  default: "डिफ़ॉल्ट",
  selectVersion: "संस्करण चुनें",
  subject: "विषय",
  searchTemplatesfolders: "टेम्पलेट/फ़ोल्डर खोजें",
  send: "भेजें",
  subject2: "विषय:",
  enterASubjectOrLeaveItBlankToContinueInTheSameThre:
    "एक विषय दर्ज करें या उसी थ्रेड में जारी रखने के लिए इसे खाली छोड़ दें",
  chooseYourChannel: "अपना चैनल चुनें",
  kl: "केएल",
  addContacts: "संपर्क जोड़ें",
  addContactsToSequence: "अनुक्रम में संपर्क जोड़ें",
  addremoveCustomContactField: "कस्टम संपर्क फ़ील्ड जोड़ें/हटाएँ",
  contactCustomFields: "संपर्क कस्टम फ़ील्ड",
  type: "प्रकार",
  typePhoneNumber: "फ़ोन नंबर टाइप करें",
  addAPhoneNumber: "एक फ़ोन नंबर जोड़ें",
  fieldType: "फ़ील्ड प्रकार",
  fieldLabel: "फ़ील्ड लेबल",
  skipTheFollowingNationalHolidaysLaborDayIndependen:
    "निम्नलिखित राष्ट्रीय छुट्टियों को छोड़ दें: मजदूर दिवस, स्वतंत्रता दिवस, मेमोरियल दिवस, धन्यवाद, क्रिसमस की पूर्व संध्या, क्रिसमस, नए साल का दिन",
  checked: "जाँचा गया",
  useTheContactsLocalTimeZoneInsteadOfTheSchedulesTi:
    "यदि संपर्क में स्थान डेटा है, तो शेड्यूल के समय क्षेत्र के बजाय संपर्क के स्थानीय समय क्षेत्र का उपयोग करें।",
  definePostreplyOrMeetingActionAndSequenceCompletio:
    "उत्तर-पश्चात या मीटिंग कार्रवाई और अनुक्रम पूर्णता मानदंड को परिभाषित करें",
  stopRepliesHandling: "उत्तरों को संभालना बंद करें",
  timeZone: "समय क्षेत्र:",
  country2: "देश",

  setMaxInitialEmailsDelaysEnabledisableOpensAndLink:
    "अधिकतम प्रारंभिक ईमेल, विलंब, ओपन और लिंक ट्रैकिंग को सक्षम/अक्षम करें",
  configuration: "कॉन्फ़िगरेशन",
  additionalInformation: "अतिरिक्त जानकारी",
  connectALinkedinAccount: "एक लिंक्डइन खाता कनेक्ट करें",
  newLinkedinAccount: "नया लिंक्डइन खाता",
  feelFreeToRevisitAnyOfThePreviousStepsAtAnyTimeToR:
    "अनुक्रम को 'लॉन्च' करने से पहले अपनी जानकारी की समीक्षा या अपडेट करने के लिए किसी भी समय पिछले चरणों में से किसी पर भी वापस जाने के लिए स्वतंत्र महसूस करें।",
  template2: "टेम्पलेट:",
  next: "अगला",
  settings2: "सेटिंग्स",
  editThisTemplateScheduleFromThe: "से इस टेम्पलेट शेड्यूल को संपादित करें",
  typeEmail: "ईमेल टाइप करें",
  templateScheduling: "टेम्पलेट शेड्यूलिंग",
  launch: "लॉन्च करें",
  linkedin: "लिंक्डइन",
  addAEmail: "एक ईमेल जोड़ें",
  addEmailAccount: "ईमेल खाता जोड़ें",
  addStep: "चरण जोड़ें",
  craftYourCampaign: "अपना अभियान तैयार करें",
  tailorYourOwnHoursToSuitSpecificSchedulingNeeds:
    "विशिष्ट शेड्यूलिंग आवश्यकताओं के अनुरूप अपने स्वयं के घंटों को अनुकूलित करें।",
  personalizedScheduling: "वैयक्तिकृत शेड्यूलिंग",
  requiredInformation: "आवश्यक जानकारी",
  chooseEmailAccountsForSendingCampaignMessages:
    "अभियान संदेश भेजने के लिए ईमेल खाते चुनें",
  accounts: "खाते",
  enterSequenceName: "अनुक्रम का नाम दर्ज करें",
  thisPageEmpowersYouToTailorYourSchedulingSequenceS:
    "यह पृष्ठ आपको अपनी वरीयताओं से मेल खाने के लिए अपनी शेड्यूलिंग अनुक्रम सेटिंग्स को अनुकूलित करने का अधिकार देता है",
  schedule: "शेड्यूल",
  useThisOptionToAddContactsToTheSequenceYouHaveCrea:
    "आपके द्वारा बनाए गए अनुक्रम में संपर्क जोड़ने के लिए इस विकल्प का उपयोग करें।",
  addProspects: "संभावित ग्राहक जोड़ें",
  save2: "सहेजें",
  days: "दिन",
  days2: "दिन",
  within: "के भीतर",
  opened: "खोला गया",
  day: "दिन",
  day2: "दिन",
  waitFor: "इंतजार करें",
  sendTestEmailToMe: "मुझे परीक्षण ईमेल भेजें",
  create: "बनाएँ",
  enterANameForCustomContactField:
    "कस्टम संपर्क फ़ील्ड के लिए एक नाम दर्ज करें",
  a: "ए",
  to2: "को",
  activated: "सक्रिय",
  currentVersion: "वर्तमान संस्करण",
  setTheNewVersionDefaultNow: "नए संस्करण को अभी डिफ़ॉल्ट सेट करें",
  enterNewName: "नया नाम दर्ज करें",
  newVersion: "नया संस्करण",
  dontForgetToSetTheNewVersionDefaultOnceYouveFinish:
    "एक बार जब आप इसे संशोधित करना समाप्त कर लें तो नए संस्करण को डिफ़ॉल्ट सेट करना न भूलें या",
  theDeletionOfThisConditionWillAlsoRemoveAllSubsequ:
    "इस शर्त को हटाने से बाद के सभी चरण भी हटा दिए जाएंगे",
  pleaseEnterANewName2: "कृपया एक नया नाम दर्ज करें:",
  aNewVersionOfTheSequenceHasBeenCreated:
    "अनुक्रम का एक नया संस्करण बनाया गया है।",
  youCanEitherEditTheCurrentVersionOrSaveItAndCreate:
    "आप या तो वर्तमान संस्करण को संपादित कर सकते हैं या इसे सहेज सकते हैं और एक नया बना सकते हैं।",
  areYouSureYouWantToProceed: "क्या आप वाकई आगे बढ़ना चाहते हैं?",
  newVersionName: "नए संस्करण का नाम",
  sequenceStart: "अनुक्रम प्रारंभ",
  chooseActions: "क्रियाएँ चुनें",
  chooseSteps: "चरण चुनें",
  enterChannel2: "चैनल दर्ज करें",
  chooseCategories: "श्रेणियां चुनें",
  htmlMode: "एचटीएमएल मोड",
  noResultsFoundForYourSearchCriteria:
    "आपके खोज मानदंडों के लिए कोई परिणाम नहीं मिला",
  fromScratch: "शुरुआत से शुरू करें",
  generateWithAi: "AI से बनाएँ",
  aiGenerateSequenceTitle: "AI से सीक्वेंस बनाएँ",
  aiGeneratePromptLabel: "आप जो आउटरीच चाहते हैं उसका वर्णन करें",
  aiGeneratePromptPlaceholder: "आप किसे और कैसे संपर्क करना चाहते हैं?",
  aiGenerateAction: "जनरेट करें",
  aiGenerateLoading: "आपका सीक्वेंस डिज़ाइन किया जा रहा है…",
  aiGenerateExample1: "फिनटेक CTO के लिए 3-चरण आउटरीच: परिचय ईमेल, LinkedIn कनेक्ट, फ़ॉलो-अप",
  aiGenerateExample2: "एक वैल्यू ईमेल और फिर LinkedIn टच से मार्केटिंग लीड्स को फिर से जोड़ें",
  aiGenerateExample3: "डेमो बुकिंग पुश: वैल्यू ईमेल, LinkedIn मैसेज, फिर आख़िरी नज",
  aiGenerateHintPrefix: "आज़माएँ",
  aiGenerateStopNote: "प्रॉस्पेक्ट के जवाब देने या मीटिंग बुक करने पर अपने आप रुक जाता है",
  aiGenerateTargetCompanyAdd: "किसी कंपनी के अनुरूप बनाएँ",
  aiGenerateTargetCompanyPlaceholder: "कंपनी का नाम या डोमेन",
  aiGenerateBuildingTitle: "आपका सीक्वेंस बनाया जा रहा है",
  aiGeneratePhaseRead: "आपकी ज़रूरत समझ रहे हैं",
  aiGeneratePhaseStudyCompany: "{company} का अध्ययन कर रहे हैं",
  aiGeneratePhaseStudyIcp: "आपके आदर्श ग्राहक का विश्लेषण कर रहे हैं",
  aiGeneratePhaseMap: "आउटरीच क्रम तैयार कर रहे हैं",
  aiGeneratePhaseWrite: "संदेश लिख रहे हैं",
  aiGeneratePhasePersonalize: "कॉपी को वैयक्तिक बना रहे हैं",
  aiGenerateSender: "प्रेषक",
  aiGenerateSenderHead: "इस खाते से भेजें",
  aiGenerateSendersCount: "{count} प्रेषक",
  aiGenerateNoSenders: "अभी तक कोई प्रेषक कनेक्ट नहीं है",
  aiGenerateSendWindow: "भेजने का समय",
  aiGenerateSendWindowHead: "इस समय के दौरान भेजें",
  aiGenerateNoSchedules: "अभी तक कोई शेड्यूल नहीं",
  aiStudioEmptyTitle: "अपने आउटरीच का वर्णन करें",
  aiStudioEmptySub: "मैं इसे कैनवास पर लाइव बनाऊँगा — ईमेल, LinkedIn, SMS, यहाँ तक कि ब्रांच भी।",
  aiStudioRefineHint: "चैट करके सुधारें, या जैसा है वैसा उपयोग करें",
  aiStudioRefinePlaceholder: "AI से सुधार करने को कहें…",
  aiStudioTurnFailed: "आपका सीक्वेंस नहीं बन सका।",
  aiStudioRetry: "पुनः प्रयास करें",
  aiStudioUndo: "पूर्ववत करें",
  aiStudioRedo: "फिर से करें",
  aiStudioEditHead: "आपका सीक्वेंस अपडेट किया गया",
  aiStudioEditRewrote: "{channel} कॉपी फिर से लिखी",
  aiStudioEditTiming: "{channel} का समय समायोजित किया",
  aiStudioEditRemoved: "एक चरण हटाया",
  aiStudioEditAdded: "एक {channel} चरण जोड़ा",
  aiStudioEditReordered: "चरणों को पुनः क्रमबद्ध किया",
  aiStudioEditStepFallback: "चरण",
  aiStudioNoop: "मैं इसे किसी चरण से नहीं जोड़ सका। चरण का नाम बताएं (जैसे “वैल्यू ईमेल”) या दोबारा कहें।",
  aiGenerateRefine: "परिष्कृत करें",
  aiGenerateRegenerate: "फिर से जनरेट करें",
  aiGenerateUseThis: "इसका उपयोग करें",
  aiGenerateDefaultName: "AI-जनरेटेड सीक्वेंस",
  aiGenerateFailed: "सीक्वेंस जनरेट नहीं हो सका। कृपया अपना प्रॉम्प्ट दोबारा लिखें।",
  aiGenerateWaitDays: "{days} दिन प्रतीक्षा करें",
  sender: "प्रेषक",
  finished: "समाप्त",
  inProgress: "प्रगति में",
  fromTemplate: "टेम्पलेट का उपयोग करें",
  newSequence: "नया अनुक्रम",
  nameOwner: "नाम मालिक",
  sort: "क्रमबद्ध करें",
  filter: "फ़िल्टर",
  exportToCSV: "CSV में निर्यात करें",
  exportRowsCsv:
    "{count} पंक्ति को CSV में निर्यात करने पर {price} क्रेडिट लगेगा। | {count} पंक्तियों को CSV में निर्यात करने पर {price} क्रेडिट लगेंगे।",
  exportSelected: "चयनित",
  exportAllMatching: "सभी मिलान",
  exportFields: "शामिल करने के लिए फ़ील्ड",
  findPeople: "लोग खोजें",
  ownedBy: "के स्वामित्व में",
  starredOnly: "केवल तारांकित",
  starred: "तारांकित",
  box2: "बॉक्स 2",
  box1: "बॉक्स 1",
  add2: "+ जोड़ें",
  lastSynced: "अंतिम बार सिंक किया गया",
  hourlyLimit: "प्रति घंटा सीमा",
  dailyLimit: "दैनिक सीमा",
  account: "खाता",
  skipTheFollowingNationalHolidaysLaborDayIndependen2:
    "निम्नलिखित राष्ट्रीय छुट्टियों को छोड़ दें: मजदूर दिवस, स्वतंत्रता दिवस, मेमोरियल दिवस, धन्यवाद, क्रिसमस की पूर्व संध्या, क्रिसमस, नए साल का दिन",
  useTheContactsLocalTimeZoneInsteadOfTheSchedulesTi2:
    "यदि संपर्क में स्थान डेटा है, तो शेड्यूल के समय क्षेत्र के बजाय संपर्क के स्थानीय समय क्षेत्र का उपयोग करें।",
  saveChanges: "परिवर्तन सहेजें",
  emailSignature: "ईमेल हस्ताक्षर",
  reset2: "रीसेट करें",
  pleaseNoteTheValueShouldBe0OrEmails:
    "कृपया ध्यान दें कि मान 0 या < {expr} होना चाहिए",
  youHaveNoScheduledTemplateYet:
    "आपके पास अभी तक कोई निर्धारित टेम्पलेट नहीं है",
  discoverPremiumOptions: "प्रीमियम विकल्प खोजें",
  mailbox: "मेलबॉक्स",
  sendingLimits: "भेजने की सीमाएं",
  connect: "कनेक्ट करें",
  joinOurCommunityOfPremiumUsersTransformingEmailEng:
    "प्यूबोरियो (Pubrio) के माध्यम से ईमेल जुड़ाव को बदलने और उत्कृष्ट बिक्री परिणाम प्राप्त करने वाले प्रीमियम उपयोगकर्ताओं के हमारे समुदाय में शामिल हों।",
  enterYourEmailAddress: "अपना ईमेल पता दर्ज करें",
  toJustMailbox: "केवल {mailNum} मेलबॉक्स तक",
  yourCurrentBasicPlanAllowsAccess:
    "आपकी वर्तमान बेसिक योजना तक पहुंच की अनुमति देती है",
  setAsDefault2: "डिफ़ॉल्ट के रूप में सेट करें",
  createNewSchedule: "नया शेड्यूल बनाएं",
  enterTemplateName: "टेम्पलेट का नाम दर्ज करें",
  googleMeet: "गूगल मीट",
  emailPreview: "ईमेल पूर्वावलोकन",
  addTemplate: "टेम्पलेट जोड़ें",
  simplifyYourWorkflowGroupYourSequenceTemplatesToKe:
    "अपने वर्कफ़्लो को सरल बनाएं! अपने अनुक्रम टेम्पलेट्स को व्यवस्थित रखने के लिए उन्हें समूहित करें, जिससे उन्हें ढूंढना, संपादित करना और आवश्यकतानुसार उपयोग करना आसान हो जाता है।",
  startCreatingPersonalizedTemplatesForYourSequences:
    "अपने अनुक्रमों के लिए वैयक्तिकृत टेम्पलेट बनाना शुरू करें! एक नया टेम्पलेट बनाने और अपने संचार को सहजता से सुव्यवस्थित करने के लिए '+' बटन पर क्लिक करें।",
  noTemplateYet: "अभी तक कोई टेम्पलेट नहीं है",
  preview: "पूर्वावलोकन",
  creatNewGroup: "नया समूह बनाएँ",
  creatNewGroup2: "नया समूह बनाएँ",
  stayOrganizedWithYourSequenceTemplatesCreateGroups:
    "अपने अनुक्रम टेम्पलेट्स के साथ व्यवस्थित रहें! अपने टेम्पलेट्स को सहजता से प्रबंधित औरL ढूंढने के लिए समूह बनाएं, जिससे आपके लिए संपादन और उपयोगिता और भी सरल हो जाती है।",
  noGroupsHaveBeenCreated: "कोई समूह नहीं बनाया गया है",
  creatNewTemplate: "नया टेम्पलेट बनाएँ",
  addSequenceTemplateToTheGroup: "समूह में अनुक्रम टेम्पलेट जोड़ें",
  byCancelingYouEnsureThatNoChangesAreMade:
    "रद्द करके, आप सुनिश्चित करते हैं कि कोई बदलाव नहीं किया गया है",
  sequenceTemplates: "अनुक्रम टेम्पलेट्स",
  youCanDeselectAndClickSaveToRemoveTheTemplateFromT:
    "आप टेम्पलेट को समूह से हटाने के लिए अचयनित कर सकते हैं और 'सहेजें' पर क्लिक कर सकते हैं",
  selectTemplateToAddToGroup: "समूह में जोड़ने के लिए टेम्पलेट चुनें",
  sequenceStatus: "अनुक्रम की स्थिति",
  sequenceStep: "अनुक्रम चरण",
  newField: "नया फ़ील्ड",
  enableTailoredDataEntryAndAdaptationToUniqueBusine:
    "अनुरूप डेटा प्रविष्टि और अद्वितीय व्यावसायिक प्रक्रियाओं के अनुकूलन को सक्षम करें",
  customContactFields: "कस्टम संपर्क फ़ील्ड",
  modality: "रूपरेखा",
  enterADescriptionForCustomContactField:
    "कस्टम संपर्क फ़ील्ड के लिए एक विवरण दर्ज करें",
  description2: "विवरण",
  enterADefaultValueForCustomContactField:
    "कस्टम संपर्क फ़ील्ड के लिए एक डिफ़ॉल्ट मान दर्ज करें",
  defaultValue: "डिफ़ॉल्ट मान",
  enterAExampleForCustomContactField:
    "कस्टम संपर्क फ़ील्ड के लिए एक उदाहरण दर्ज करें",
  example: "उदाहरण",
  enterPicklistoptionsForCustomContactField:
    "कस्टम संपर्क फ़ील्ड के लिए पिकलिस्ट_विकल्प दर्ज करें",
  newCustomContactFields: "नए कस्टम संपर्क फ़ील्ड",
  engagementMetrics: "जुड़ाव मेट्रिक्स",
  message: "संदेश",
  to3: "को:",
  receiver: "प्राप्तकर्ता",
  claraHan: "क्लारा हान",
  createNewCategory: "नई श्रेणी बनाएँ",
  bestRegards: "सादर,",
  thanksAgain: "पुनः धन्यवाद!",
  lookingForwardToAFruitfulCollaborationIfTheresAnyt:
    "एक उपयोगी सहयोग की उम्मीद है। यदि हमें शुरू करने से पहले कुछ भी विशिष्ट संबोधित करने की आवश्यकता है, तो कृपया हमें बताने में संकोच न करें।",
  kingLaiAdviser: "किंग लाइ (सलाहकार)",
  iAppreciateTheIntroductionToOurMainContacts:
    "मैं हमारे मुख्य संपर्कों के परिचय की सराहना करता हूँ:",
  contacted: "संपर्क किया गया",
  sendTestEmail: "परीक्षण ईमेल भेजें",
  thankYouSoMuchForTheWarmWelcomeWereEquallyExcitedA:
    "गर्मजोशी से स्वागत के लिए बहुत-बहुत धन्यवाद! हम भी Pubrio GTM के साथ अपनी परियोजना शुरू करने और वेंचर एआई की टीम का हिस्सा बनने के लिए समान रूप से उत्साहित हैं।",
  hiJacqueline: "नमस्ते जैकलीन,",
  nov152023118Pm: "नवंबर 15, 2023, 1:18 अपराह्न",
  message2: "{total_messages} संदेश",
  topEcommerceAutomationPlatf: "शीर्ष ई-कॉमर्स स्वचालन प्लेटफ़...",
  cindyHsu: "सिंडी सू",
  includeSignature: "हस्ताक्षर शामिल करें",
  ch: "सीएच",
  continueOnFail: "विफल होने पर जारी रखें",
  welcomeToPubrioGtm: "Pubrio GTM में आपका स्वागत है",
  replyToPreviousThread: "पिछले थ्रेड का उत्तर दें",
  sendAutomatic: "स्वचालित {title} भेजें",
  searchByContacts: "संपर्कों द्वारा खोजें",
  processingErrorOccurredMaximumNumberOfUniqueContac:
    "प्रसंस्करण त्रुटि हुई: प्रति माह अद्वितीय संपर्कों की अधिकतम संख्या तक पहुंच गया है",
  oct140954Pm: "अक्टूबर 14, 09:54 अपराह्न",
  shiftdragToMoveTheCanvas: "कैनवास को स्थानांतरित करने के लिए Shift+drag करें",
  active: "सक्रिय",
  inactive: "निष्क्रिय",
  archived: "संग्रहीत",
  archive: "संग्रहीत करें",
  unarchive: "संग्रह से बाहर करें",
  archivedSuccessfully: "सफलतापूर्वक संग्रहीत",
  unarchivedSuccessfully: "सफलतापूर्वक संग्रह से बाहर किया गया",
  sequenceArchivedSuccess: "अनुक्रम सफलतापूर्वक संग्रहीत",
  sequenceUnarchivedSuccess: "अनुक्रम सफलतापूर्वक संग्रह से बाहर किया गया",
  alphabetical: "वर्णमाला अनुसार",
  creationDate: "बनाने की तारीख",
  viewDate: "देखने की तारीख",
  staredFirst: "पहले तारांकित",
  SaveAsANewVersion: "एक नए संस्करण के रूप में सहेजें",
  SaveCurrentVersion: "वर्तमान संस्करण सहेजें",
  schedules: "शेड्यूल",
  EmailsSentPerDay: "प्रति दिन भेजे गए ईमेल",
  EmailsSentPerHour: "प्रति घंटा भेजे गए ईमेल",
  DelayBetweenEachEmailSent: "प्रत्येक भेजे गए ईमेल के बीच विलंब (सेकंड)",
  RecommendedDailyLimit:
    "अनुशंसित दैनिक सीमा: 50-100 ईमेल, 100+ के लिए अपवाद केवल तभी जब आप अत्यधिक वैयक्तिकृत अभियान भेज रहे हों और एक मजबूत डोमेन प्रतिष्ठा बनाए रखें।",
  RecommendedHourlyLimit:
    "अनुशंसित प्रति घंटा सीमा: ईमेल की संख्या 100 से कम रखें। प्रति घंटे 120 ईमेल से अधिक न करें।",
  currentDelayAllows:
    "वर्तमान विलंब आपको प्रति घंटे अधिकतम 120 ईमेल भेजने की अनुमति देता है।",
  SetAsDefault: "डिफ़ॉल्ट के रूप में सेट करें",
  monday: "सोमवार",
  tuesday: "मंगलवार",
  wednesday: "बुधवार",
  thursday: "गुरुवार",
  friday: "शुक्रवार",
  saturday: "शनिवार",
  sunday: "रविवार",
  Templates: "टेम्पलेट",
  Analytics: "विश्लेषण",
  Meetings: "मीटिंग",
  Settings: "सेटिंग्स",
  EnterTemplateName: "टेम्पलेट का नाम दर्ज करें",
  EnterGroupName: "समूह का नाम दर्ज करें",
  ExportAllData: "सभी डेटा निर्यात करें",
  ExportAsCSV: "सीएसवी के रूप में निर्यात करें",
  Total: "कुल",
  Opened: "खोला गया",
  Clicked: "क्लिक किया गया",
  NotOpened: "नहीं खोला गया",
  Bounced: "बाउंस हुआ",
  Replied: "उत्तर दिया गया",
  Failed: "विफल",
  Inbox: "इनबॉक्स",
  Report: "रिपोर्ट",
  Log: "लॉग",
  UseThisTemplate: "इस टेम्पलेट का उपयोग करें",
  UseThisFolder: "इस फ़ोल्डर का उपयोग करें",
  UpdateThisTemplate: "इस टेम्पलेट को अपडेट करें",
  RemoveFromGroup: "समूह से हटाएँ",
  DeleteThisTemplate: "इस टेम्पलेट को हटाएँ",
  MarkAsFinished: "समाप्त के रूप में चिह्नित करें",
  Remove: "हटाएँ",
  Pause: "रोकें",
  Resume: "फिर से शुरू करें",
  AddToSequence: "अनुक्रम में जोड़ें",
  Export: "निर्यात करें",
  InProgress: "प्रगति में",
  Finished: "समाप्त",
  Paused: "रोका गया",
  Engaged: "संलग्न",
  Reply: "उत्तर",
  NotSent: "नहीं भेजा गया",
  MaxNumberOfEmailsPerDay: "प्रति दिन ईमेल की अधिकतम संख्या",
  MaxNumberOfEmailsPerHour: "प्रति घंटे ईमेल की अधिकतम संख्या",
  EnableOpensTracking: "ओपन ट्रैकिंग सक्षम करें",
  EnableReplyTracking: "उत्तर ट्रैकिंग सक्षम करें",
  EnableClickTracking: "क्लिक ट्रैकिंग सक्षम करें",
  ReplyByMessage: "संदेश द्वारा उत्तर",
  BookAMeeting: "एक मीटिंग बुक करें",
  ClickOnLink: "लिंक पर क्लिक करें",
  CreateManually: "मैन्युअल रूप से बनाएँ",
  AddContactsToTheSequenceManually:
    "एक-एक करके मैन्युअल रूप से अनुक्रम में संपर्क जोड़ें।",
  ImportFromCSV: "सीएसवी से आयात करें",
  UploadCSVFileToAddContactsToSequence:
    "अनुक्रम में संपर्क जोड़ने के लिए एक सीएसवी फ़ाइल अपलोड करें।",
  AddFromExisting: "मौजूदा से जोड़ें",
  AddExistingContactsIntoTheSequence: "मौजूदा संपर्कों को अनुक्रम में जोड़ें।",
  ChooseFile: "फ़ाइल चुनें",
  MapAttributes: "विशेषताओं को मैप करें",
  Options: "विकल्प",
  ReviewAndImport: "समीक्षा और आयात करें",
  UpdateMissingFields: "लापता फ़ील्ड अपडेट करें",
  DetectContactTimeZoneAutomatically:
    "संपर्क समय क्षेत्र को स्वचालित रूप से पहचानें",
  account_website: "खाता वेबसाइट",
  linkedin_url: "लिंक्डइन यूआरएल",
  raw_address: "कच्चा पता",
  first_name: "पहला नाम",
  last_name: "अंतिम नाम",
  account_name: "खाता नाम",
  Identifier: "पहचानकर्ता",
  firstName: "पहला नाम",
  lastName: "अंतिम नाम",
  EnterJobTitleOrPosition: "नौकरी का शीर्षक या स्थिति दर्ज करें",
  EnterCompanyName: "कंपनी का नाम दर्ज करें",
  EnterYourCustomerID: "अपना ग्राहक आईडी दर्ज करें",
  EnterCompanyWebsiteURL: "कंपनी वेबसाइट यूआरएल दर्ज करें",
  EnterLinkedInProfileURL: "लिंक्डइन प्रोफ़ाइल यूआरएल दर्ज करें",
  EnterCity: "शहर दर्ज करें",
  versionName: "संस्करण का नाम",
  PleaseEnterANewVersionName: "कृपया एक नया संस्करण नाम दर्ज करें",
  EnterNewVersionName: "नया संस्करण नाम दर्ज करें",
  versions: "संस्करण",
  SequenceNameUpdatedSuccessfully: "अनुक्रम का नाम सफलतापूर्वक अपडेट किया गया",
  SequenceNameCannotBeEmpty: "अनुक्रम का नाम खाली नहीं हो सकता",

  delete_success: "सफलतापूर्वक हटाया गया",
  delete_fail: "हटाना विफल रहा",
  set_default_success: "सफलतापूर्वक डिफ़ॉल्ट सेट किया गया",
  DuplicateVersionSuccessfully: "संस्करण को सफलतापूर्वक डुप्लिकेट किया गया",
  UpdateSuccessfully: "सफलतापूर्वक अपडेट किया गया",
  AddToGroupSuccessfully: "सफलतापूर्वक समूह में जोड़ा गया",
  sendAutomaticEmail: "स्वचालित ईमेल भेजें",
  sendMessage: "संदेश भेजें",
  uploadFailed: "अपलोड विफल रहा",
  InvalidEmailFormat: "अमान्य ईमेल प्रारूप",
  FailedToSetUpEmailAccount: "ईमेल खाता सेट करने में विफल",
  noAccount: "कोई खाता नहीं",
  addAnAccountToPersonalizYourExperienceAndUnlock:
    "अपने अनुभव को वैयक्तिकृत करने और प्रीमियम सुविधाओं को अनलॉक करने के लिए एक खाता जोड़ें",
  trackingFeaturesForThisSequence: "इस अनुक्रम के लिए ट्रैकिंग सुविधाएँ।",
  UpdatedSuccessfully: "सफलतापूर्वक अपडेट किया गया",
  update_fail: "अपडेट विफल रहा",
  connectYourGoogleMeetAccountToPubrioConversations:
    "अपने Google Meet खाते को Pubrio वार्तालापों से कनेक्ट करें",
  set_default_fail: "डिफ़ॉल्ट सेट विफल रहा",
  duplicatedSuccessfully: "सफलतापूर्वक डुप्लिकेट किया गया",
  noStepsInSequencePleaseAddStepsFirst:
    "अनुक्रम में कोई चरण नहीं है, कृपया पहले चरण जोड़ें",
  addLabelSuccessfully: "सफलतापूर्वक लेबल जोड़ा गया",
  PleaseEnterSequenceName: "कृपया एक अनुक्रम नाम दर्ज करें",
  sequenceNameCannotBeEmpty: "अनुक्रम का नाम खाली नहीं हो सकता",
  sequenceNameUpdatedSuccessfully: "अनुक्रम का नाम सफलतापूर्वक अपडेट किया गया",
  createStepFlowSuccessfully: "चरण प्रवाह सफलतापूर्वक बनाया गया",
  updateStepFlowSuccessfully: "चरण प्रवाह सफलतापूर्वक अपडेट किया गया",
  testEmailSentSuccessfully: "परीक्षण ईमेल सफलतापूर्वक भेजा गया",
  removeEmailAccountSuccessfully: "ईमेल खाता सफलतापूर्वक हटाया गया",
  pleaseSelectTheDataToBeExported: "कृपया निर्यात करने के लिए डेटा का चयन करें",
  confirm: "पुष्टि करें",
  saveFailed: "सहेजना विफल रहा",
  deleteThisStep: "इस चरण को हटाएँ",
  Email: "ईमेल",
  LinkedIn: "लिंक्डइन",
  API: "एपीआई",
  Task: "कार्य",
  Custom: "कस्टम",
  proceedImmediately: "तुरंत आगे बढ़ें",
  dayss: "दिन/s",
  hourss: "घंटा/s",
  minutess: "मिनट/s",
  theConditionAndAllTheStepsThatFollowFromItWillBeDeleted:
    "शर्त और उसके बाद के सभी चरण हटा दिए जाएंगे, क्या आप जारी रखना चाहते हैं?",
  sendConnectionRequest: "कनेक्शन अनुरोध भेजें",
  viewProfile: "प्रोफ़ाइल देखें",
  callAnAPI: "एक एपीआई कॉल करें",
  createAManualTask: "एक मैन्युअल कार्य बनाएँ",
  hasEmailAddress: "ईमेल पता है",
  hasLinkedInURL: "लिंक्डइन यूआरएल है",
  hasPhoneNumber: "फ़ोन नंबर है",
  customCondition: "कस्टम शर्त",
  openedEmail: "ईमेल खोला गया",
  clickOnLinkInEmail: "ईमेल में लिंक पर क्लिक करें",
  unsubscribeFromEmail: "ईमेल से सदस्यता समाप्त करें",
  bookAMeeting: "एक मीटिंग बुक करें",
  acceptedInvite: "आमंत्रण स्वीकार किया गया",
  conditions: "शर्तें",
  Yes: "हाँ",
  No: "नहीं",
  newVariable: "नया चर",
  selectVariable: "चर चुनें",
  ifLeadVariable: "यदि लीड चर",
  condition: "शर्त",
  selectCondition: "शर्त चुनें",
  value: "मान",
  contains: "शामिल है",
  is_equal_to: "के बराबर है",
  is_empty: "खाली है",
  is_not_empty: "खाली नहीं है",
  picture: "चित्र",
  company_domain: "कंपनी डोमेन",
  company_name: "कंपनी का नाम",
  icebreaker: "आइसब्रेकर",
  change_steps_conditions: "चरण/शर्तें बदलें",
  ForceASpecificSenderForThisStep:
    "इस चरण के लिए एक विशिष्ट प्रेषक को मजबूर करें",
  method: "विधि",
  selectASender: "एक प्रेषक चुनें",
  assignAPITaskTo: "एपीआई कार्य को असाइन करें",
  enterCompanyNamesAndPressEnterKey:
    "कंपनी के नाम दर्ज करें और एंटर कुंजी दबाएं",
  feelFreeToEditTheContentAndSaveYourChangesDirectly:
    "सामग्री को संपादित करने और क्लिक करने के तुरंत बाद अपने परिवर्तनों को सहेजने के लिए स्वतंत्र महसूस करें।",
  permission: "अनुमति",
  addAnyAdditionalStepsOrConditionsAsNeeded:
    "आवश्यकतानुसार कोई भी अतिरिक्त चरण या शर्तें जोड़ें",
  reviewAndFinalizeSequenceSettingsAndPreferences:
    "अनुक्रम सेटिंग्स और वरीयताओं की समीक्षा करें और अंतिम रूप दें",

  // setting
  nameOnCard: "कार्ड पर नाम",
  expiryDate: "समाप्ति तिथि",
  cvccvv: "सीवीसी/सीवीवी",
  details: "विवरण",
  notification: "अधिसूचना",
  markAsAllRead: "सभी को पढ़ा गया के रूप में चिह्नित करें",
  Personal: "व्यक्तिगत",
  profile: "प्रोफ़ाइल",
  extensions: "एक्सटेंशन",
  notifications: "सूचनाएँ",
  Company: "कंपनी",
  roles: "भूमिकाएँ",
  teams: "टीमें",
  "current-usage": "योजना और उपयोग",
  "upgrade-plan": "योजना अपग्रेड करें",
  Products: "उत्पाद",
  APIKeys: "एपीआई कुंजी",
  popular: "लोकप्रिय",
  priceSequence: "अनुक्रम (जल्द ही आ रहा है)",
  free: "मुफ़्त",
  lite: "लाइट",
  growth: "ग्रोथ",
  business: "व्यवसाय",
  enterEmailAddressesMultipleCommaSeparated:
    "ईमेल पते दर्ज करें [कई, कॉमा-अलग]",
  sharingRulesSelectTeamToEnableThisField:
    "साझाकरण नियम [इस फ़ील्ड को सक्षम करने के लिए टीम का चयन करें]",
  allSeatsAreCurrentlyOccupiedAnyNewUsersNeedingAPaidSeatWillIncurAdditionalCharges:
    "सभी सीटें वर्तमान में भरी हुई हैं। किसी भी नए उपयोगकर्ता को भुगतान वाली सीट की आवश्यकता होने पर अतिरिक्त शुल्क लगेगा।",
  additionalUserLicence: "अतिरिक्त उपयोगकर्ता लाइसेंस",
  costPerBillingCycle: "कुल लागत (बिलिंग चक्र)",
  "select...": "चुनें...",
  invite: "आमंत्रित करें",
  services: "सेवाएं",
  "services-group": "सेवा समूह",
  "all-notification-services": "सभी अधिसूचना सेवाएं",
  "services-status-update": "सेवा स्थिति अपडेट",
  "system-group": "सिस्टम समूह",
  "all-notification-system": "सभी अधिसूचना प्रणाली",
  "system-new-feature-release": "सिस्टम नई सुविधा रिलीज",
  "system-news-letter": "सिस्टम न्यूज़ लेटर",
  "system-generic-alarm": "सिस्टम सामान्य अलार्म",
  markAsRead: "पढ़ा गया के रूप में चिह्नित करें",
  showMore: "और दिखाएँ",
  changedStatusTo: "ने स्थिति बदल दी",
  "access-management-group": "पहुंच प्रबंधन समूह",
  "access-management-roles": "पहुंच प्रबंधन भूमिकाएँ",
  "access-management-create-roles": "पहुंच प्रबंधन भूमिकाएँ बनाएँ",
  "access-management-edit-user-roles":
    "पहुंच प्रबंधन उपयोगकर्ता भूमिकाएँ संपादित करें",
  "access-management-add-role-to-users":
    "पहुंच प्रबंधन उपयोगकर्ताओं को भूमिका जोड़ें",
  "access-management-delete-users-role":
    "पहुंच प्रबंधन उपयोगकर्ताओं की भूमिका हटाएँ",
  "access-management-delete-roles": "पहुंच प्रबंधन भूमिकाएँ हटाएँ",
  "access-management-read-roles-and-role-users":
    "पहुंच प्रबंधन भूमिकाएँ और भूमिका उपयोगकर्ता पढ़ें",
  "access-management-teams": "पहुंच प्रबंधन टीमें",
  "access-management-delete-users-team":
    "पहुंच प्रबंधन उपयोगकर्ताओं की टीम हटाएँ",
  "access-management-read-teams-sharing-rules-teams-users":
    "पहुंच प्रबंधन टीमें साझाकरण नियम टीमें उपयोगकर्ता पढ़ें",
  "access-management-create-teams": "पहुंच प्रबंधन टीमें बनाएँ",
  "access-management-edit-teams-sharing-rules":
    "पहुंच प्रबंधन टीमें साझाकरण नियम संपादित करें",
  "access-management-delete-teams-sharing-rules":
    "पहुंच प्रबंधन टीमें साझाकरण नियम हटाएँ",
  "access-management-add-and-update-team-to-users":
    "पहुंच प्रबंधन उपयोगकर्ताओं को टीम जोड़ें और अपडेट करें",
  "access-management-read-team-relations": "पहुंच प्रबंधन टीम संबंध पढ़ें",
  "access-management-modify-team-relations":
    "पहुंच प्रबंधन टीम संबंध संशोधित करें",
  "intent-signal-group": "इरादा सिग्नल समूह",
  "market-intent-signal": "बाजार इरादा सिग्नल",
  "web-intent-signal": "वेब इरादा सिग्नल",
  "web-intent-signal-add-and-activate":
    "वेब इरादा सिग्नल जोड़ें और सक्रिय करें",
  "web-intent-signal-read-data": "वेब इरादा सिग्नल डेटा पढ़ें",
  "web-intent-signal-export-data": "वेब इरादा सिग्नल डेटा निर्यात करें",
  "web-intent-signal-delete-data": "वेब इरादा सिग्नल डेटा हटाएँ",
  "web-intent-signal-read-analytic": "वेब इरादा सिग्नल विश्लेषण पढ़ें",
  "search-group": "खोज समूह",
  "company-search": "कंपनी खोज",
  "prospects-search": "संभावित ग्राहक खोज",
  "sequence-group": "अनुक्रम समूह",
  sequences: "अनुक्रम",
  "service-create-request": "सेवा अनुरोध बनाएँ",
  "service-update-request": "सेवा अनुरोध अपडेट करें",
  "service-read-request": "सेवा अनुरोध पढ़ें",
  "service-delete-service-attachment": "सेवा अनुलग्नक हटाएँ",
  "service-delete-service-message": "सेवा संदेश हटाएँ",
  "service-send-and-edit-service-message": "सेवा संदेश भेजें और संपादित करें",
  "service-upload-service-attachment": "सेवा अनुलग्नक अपलोड करें",
  "settings-group": "सेटिंग्स समूह",
  "custom-fields": "कस्टम फ़ील्ड",
  "user-management-and-billing-group": "उपयोगकर्ता प्रबंधन और बिलिंग समूह",
  "billing-read-credit-card": "बिलिंग क्रेडिट कार्ड पढ़ें",
  "billing-download-invoice": "बिलिंग चालान डाउनलोड करें",
  "billing-read-invoice": "बिलिंग चालान पढ़ें",
  "credit-usage": "क्रेडिट उपयोग",
  "credit-usage-read-profile-detail": "क्रेडिट उपयोग प्रोफ़ाइल विवरण पढ़ें",
  "credit-usage-read-profile-usage": "क्रेडिट उपयोग प्रोफ़ाइल उपयोग पढ़ें",
  "profile-and-team": "प्रोफ़ाइल और टीम",
  "profile-and-team-invite-team-member":
    "प्रोफ़ाइल और टीम टीम सदस्य को आमंत्रित करें",
  "profile-and-team-update-profile": "प्रोफ़ाइल और टीम प्रोफ़ाइल अपडेट करें",
  "profile-and-team-delete-team-member": "प्रोफ़ाइल और टीम टीम सदस्य हटाएँ",
  "profile-and-team-get-user-secret-token":
    "प्रोफ़ाइल और टीम उपयोगकर्ता गुप्त टोकन प्राप्त करें",
  "profile-and-team-update-user-and-password":
    "प्रोफ़ाइल और टीम उपयोगकर्ता और पासवर्ड अपडेट करें",
  "profile-and-team-read-profile-users":
    "प्रोफ़ाइल और टीम प्रोफ़ाइल उपयोगकर्ता पढ़ें",
  "upgrade-plan-read-subscription": "योजना अपग्रेड करें सदस्यता पढ़ें",
  "upgrade-plan-upgrade-subscription":
    "योजना अपग्रेड करें सदस्यता अपग्रेड करें",
  "all-access-access-management-roles": "सभी पहुंच पहुंच प्रबंधन भूमिकाएँ",
  "all-access-access-management-teams": "सभी पहुंच पहुंच प्रबंधन टीमें",
  "all-access-market-intent-signal-page": "सभी पहुंच बाजार इरादा सिग्नल पृष्ठ",
  "all-access-web-intent-signal-page": "सभी पहुंच वेब इरादा सिग्नल पृष्ठ",
  "all-access-company-search-page": "सभी पहुंच कंपनी खोज पृष्ठ",
  "all-access-prospects-search-page": "सभी पहुंच संभावित ग्राहक खोज पृष्ठ",
  "all-access-sequence-page": "सभी पहुंच अनुक्रम पृष्ठ",
  "all-access-service-page": "सभी पहुंच सेवा पृष्ठ",
  "all-access-custom-fields-page": "सभी पहुंच कस्टम फ़ील्ड पृष्ठ",
  "all-access-billing-page": "सभी पहुंच बिलिंग पृष्ठ",
  "all-access-credit-usage-page": "सभी पहुंच क्रेडिट उपयोग पृष्ठ",
  "all-access-profile-and-team-page": "सभी पहुंच प्रोफ़ाइल और टीम पृष्ठ",
  newPermissionProfile: "नई अनुमति प्रोफ़ाइल",
  enterAName: "एक नाम दर्ज करें",
  addUserToRole: "उपयोगकर्ता को भूमिका में जोड़ें",
  changePermission: "अनुमति बदलें",
  selectPermissionProfiles: "अनुमति प्रोफ़ाइल चुनें",
  backToRoles: "भूमिकाओं पर वापस जाएं",
  updateRole: "भूमिका अपडेट करें",
  enterADescription: "एक विवरण दर्ज करें",
  createANewRole: "एक नई भूमिका बनाएँ",
  remove_role_title: "उपयोगकर्ता से भूमिका हटाएँ?",
  remove_team_title: "टीम से उपयोगकर्ता हटाएँ?",
  AreYouSureYouWantToRemoveThisRole:
    "क्या आप वाकई इस भूमिका को हटाना चाहते हैं?",
  AreYouSureYouWantToRemoveThisUserFromTheTeam:
    "क्या आप वाकई इस उपयोगकर्ता को टीम से हटाना चाहते हैं?",
  ProceedingWithDeletionWillPermanentlyRemoveTheRoleFromTheUser:
    "उपयोगकर्ता तुरंत इससे जुड़ी सभी अनुमतियों तक पहुंच खो देगा।",
  ProceedingWithDeletionWillPermanentlyRemoveTheUserFromTheTeam:
    "वे साझा संसाधनों, असाइनमेंट, या टीम द्वारा प्रबंधित किसी भी साझाकरण नियमों तक पहुंच खो सकते हैं।",
  relation: "संबंध",
  newTeam: "नई टीम",
  "full-sharing-market-intent-signal-data":
    "पूर्ण साझाकरण बाजार इरादा सिग्नल डेटा",
  "full-sharing-web-intent-signal-data": "पूर्ण साझाकरण वेब इरादा सिग्नल डेटा",
  "full-sharing-company-search-data": "पूर्ण साझाकरण कंपनी खोज डेटा",
  "full-sharing-prospects-search-data": "पूर्ण साझाकरण संभावित ग्राहक खोज डेटा",
  "full-sharing-sequence-data": "पूर्ण साझाकरण अनुक्रम डेटा",
  "full-sharing-service-data": "पूर्ण साझाकरण सेवा डेटा",
  "share-service-attachments": "सेवा अनुलग्नक साझा करें",
  "share-service-messages": "सेवा संदेश साझा करें",
  RenameSharingRules: "साझाकरण नियमों का नाम बदलें",
  enterNewSharingRulesNameBelow: "नीचे नया साझाकरण नियम नाम दर्ज करें:",
  enterNewSharingRulesName: "नया साझाकरण नियम नाम दर्ज करें",
  enterNewSharingRulesDescriptionBelow:
    "नीचे नया साझाकरण नियम विवरण दर्ज करें:",
  enterNewSharingRulesDescription: "नया साझाकरण नियम विवरण दर्ज करें",
  enterSharingRulesName: "साझाकरण नियम नाम दर्ज करें",
  currentUsers: "वर्तमान उपयोगकर्ता",
  pendingUsers: "लंबित उपयोगकर्ता",
  addRole: "भूमिका जोड़ें",
  addTeam: "टीम जोड़ें",
  addPermission: "अनुमति जोड़ें",
  "Re-invite": "पुनः आमंत्रित करें",
  relations: "संबंध",
  "is-parent-of": "का माता-पिता है",
  addRelation: "संबंध जोड़ें",
  deleteRelation: "संबंध हटाएँ",
  updateRelation: "संबंध अपडेट करें",
  API_Keys: "एपीआई कुंजी",
  createNewKey: "नई कुंजी बनाएँ",
  createAPIKey: "एपीआई कुंजी बनाएँ",
  APIs: "एपीआई",
  setAsMasterKey: "मास्टर कुंजी के रूप में सेट करें",
  "growth-annual": "ग्रोथ-वार्षिक",
  business: "व्यवसाय",
  "website-intent-data": "वेबसाइट इरादा डेटा",
  "demo-identification": "डेमो पहचान",

  activateTheNewVersionNow: "नए संस्करण को अभी सक्रिय करें",

  feedbackSendSuccessfully: "प्रतिक्रिया सफलतापूर्वक भेजी गई",
  feedbackSendFailed: "प्रतिक्रिया भेजना विफल रहा",

  autoSave: "ऑटो सेव",
  serviceDescShowMore: "और दिखाएं",
  serviceDescShowLess: "कम दिखाएं",
  members: "सदस्य",
  shareTo: "साझा करें...",
  findTeamMembers: "टीम के सदस्यों को ढूंढें",
  select: "चुनें",
  whenBalanceFallsBelow: "जब बैलेंस नीचे गिरता है",
  automaticallyTopUp: "स्वचालित रूप से टॉप अप करें",
  autoTopupWillAutomaticallyChargeYourPaymentMethodT:
    "ऑटो टॉप-अप स्वचालित रूप से आपके भुगतान विधि से चार्ज करेगा। इसे अक्षम करने के लिए, इस बॉक्स को अनचेक छोड़ दें",
  enableAutoTopups: "ऑटो टॉप-अप सक्षम करें",
  validThru: "के माध्यम से मान्य",
  currentBalance: "वर्तमान बैलेंस",
  cardHolder: "कार्ड धारक",
  gotIt: "समझ गया",
  pleaseEnsureYourPaymentMethodIsUptodateAndThatYouA:
    "कृपया सुनिश्चित करें कि आपकी भुगतान विधि अद्यतित है और सक्षम करने से पहले आप इस स्वचालित प्रक्रिया से सहज हैं।",
  thresholdCredits: "सीमा: {creditLimit} क्रेडिट",
  creditAmountCredits: "क्रेडिट राशि: {choosedTopUpCredit} क्रेडिट",
  enablingAutoTopupsWillAutomaticallyAddCreditsToYou:
    "ऑटो टॉप-अप सक्षम करने से आपका बैलेंस निर्दिष्ट सीमा से नीचे गिरने पर आपके खाते में स्वचालित रूप से क्रेडिट जुड़ जाएगा। इसके परिणामस्वरूप आपकी चयनित भुगतान विधि पर स्वचालित शुल्क लग सकता है।",
  thisWillAutomaticallyAddCreditsToYourAccountWhenev:
    "जब भी आपका बैलेंस {creditLimit} क्रेडिट से नीचे जाएगा, यह आपके खाते में स्वचालित रूप से {choosedTopUpCredit} क्रेडिट जोड़ देगा",
  autoTopupNotice: "ऑटो टॉप-अप नोटिस",
  roleName: "भूमिका का नाम",
  addUser: "उपयोगकर्ता जोड़ें",
  newRole: "नई भूमिका",
  userName: "उपयोगकर्ता का नाम",
  joined: "शामिल हुआ",
  thisRoleCurrentlyHasNoUsersAssignedToItStartAddingTeamMembersToDefineTheirResponsibilitiesAndStreamlineYourWorkflow:
    "वर्तमान में इस भूमिका में कोई उपयोगकर्ता नहीं है। अपनी जिम्मेदारियों को परिभाषित करने और अपने वर्कफ़्लो को सुव्यवस्थित करने के लिए टीम के सदस्यों को जोड़ना शुरू करें।",
  noUsersAssigned: "कोई उपयोगकर्ता असाइन नहीं किया गया है",

  addUserToTeam: "टीम में उपयोगकर्ता जोड़ें",
  user: "उपयोगकर्ता",
  sharingRuleGroup: "साझाकरण नियम समूह",
  updateTeam: "टीम अपडेट करें",
  createANewTeam: "एक नई टीम बनाएँ",
  backToTeams: "टीमों पर वापस जाएं",
  listOfSharingRules: "साझाकरण नियमों की सूची",
  sharingRules: "साझाकरण नियम",
  manageSharingRules: "साझाकरण नियम प्रबंधित करें",
  CreateAndCustomizeSharingRulesToControlAccessForDifferentUsersClickTheButtonBelowToAddNewSharingRules:
    "विभिन्न उपयोगकर्ताओं के लिए पहुंच को नियंत्रित करने के लिए साझाकरण नियम बनाएँ और अनुकूलित करें। नए साझाकरण नियम जोड़ने के लिए नीचे दिए गए बटन पर क्लिक करें।",
  newSharingRules: "नए साझाकरण नियम",

  // price
  exportLimit: "निर्यात सीमा",
  customRolePermission: "कस्टम भूमिका अनुमति",
  teamManagement: "टीम प्रबंधन",
  API: "एपीआई",
  linkedinAccount: "लिंक्डइन खाता",
  perPageLimit: "प्रति पृष्ठ सीमा",
  recordUploadLimit: "रिकॉर्ड अपलोड सीमा",
  creditRollover: "क्रेडिट रोलओवर",
  quotaSharing: "कोटा साझाकरण",
  quotaAdjustment: "कोटा समायोजन",
  add_On: "ऐड-ऑन",
  topUpCredits: "क्रेडिट टॉप अप करें",
  webVisitorIdentification: "वेब आगंतुक पहचान",
  dataExportCredit: "डेटा निर्यात",
  companySearchCredit: "कंपनी खोज",
  peopleSearchCredit: "संभावित ग्राहक खोज",
  emailRedeemCredit: "ईमेल खोज",
  phoneNumberRedeemCredit: "फ़ोन नंबर खोज",
  recordSelection: "रिकॉर्ड चयन",
  portal: "पोर्टल",
  queryLimitPerHour: "प्रति घंटे क्वेरी सीमा",
  queryLimitPerDay: "प्रति दिन क्वेरी सीमा",
  callLimitPerHour: "प्रति घंटे कॉल सीमा",
  callLimitPerDay: "प्रति दिन कॉल सीमा",
  callLimitPerMonth: "प्रति माह कॉल सीमा",
  basicSequencing: "मूल अनुक्रमण",
  numberOfSequences: "अनुक्रमों की संख्या",
  numberOfMailboxesPerUser: "प्रति उपयोगकर्ता मेलबॉक्स की संख्या",
  numberOfLinkedinAccountPerUser: "प्रति उपयोगकर्ता लिंक्डइन खाते की संख्या",
  numberOfSlackAccountPerUser: "प्रति उपयोगकर्ता स्लैक खाते की संख्या",
  automatedFollowUp: "स्वचालित फॉलो-अप",
  advancedSequencing: "उन्नत अनुक्रमण",
  abTesting: "ए/बी परीक्षण",
  multipleEmailTemplates: "कई ईमेल टेम्पलेट",
  reporting: "रिपोर्टिंग",
  emailOpenTracking: "ईमेल ओपन ट्रैकिंग",
  emailClickTracking: "ईमेल क्लिक ट्रैकिंग",
  emailReplyTracking: "ईमेल उत्तर ट्रैकिंग",
  support: "समर्थन",
  priorityEmailSupport: "प्राथमिकता ईमेल समर्थन",
  companySelectionLimit: "कंपनी चयन सीमा",
  prospectSelectionLimit: "संभावित ग्राहक चयन सीमा",
  totalPageLimit: "कुल पृष्ठ सीमा",
  pricingYear: "वर्ष",
  "growth-annual": "ग्रोथ",
  "business-annual": "व्यवसाय",
  pricingSearch: "खोज",
  pricingSearches: "खोजें",
  pricingMonth: "माह",
  pricingYear: "वर्ष",
  topupCredit: "टॉपअप क्रेडिट",
  perUserPerYear: "प्रति उपयोगकर्ता, प्रति माह \n सालाना बिल किया गया",
  perUserPerMonth: "प्रति उपयोगकर्ता, प्रति माह \n मासिक बिल किया गया",
  customCredits: "कस्टम क्रेडिट",
  customSearches: "कस्टम खोजें",
  queryLimitPerMonth: "प्रति माह क्वेरी सीमा",
  customized: "कस्टम",
  custom: "कस्टम",
  free: "मुफ़्त",
  growth: "ग्रोथ",
  business: "व्यवसाय",
  organization: "संगठन",
  search: "खोज",

  // setting users
  pleaseSelectTheUserYouWantToAdd:
    "कृपया उन उपयोगकर्ताओं का चयन करें जिन्हें आप जोड़ना चाहते हैं",
  pleaseSelectTheUserYouWantToDelete:
    "कृपया उन उपयोगकर्ताओं का चयन करें जिन्हें आप हटाना चाहते हैं",
  pleaseSelectTheUserYouWantToAddPermission:
    "कृपया उन उपयोगकर्ताओं का चयन करें जिन्हें आप अनुमति देना चाहते हैं",

  range_separator: "से",
  start_placeholder: "शुरू करने की तिथि",
  end_placeholder: "समाप्ति तिथि",
  redirectSoon: "जल्द ही रीडायरेक्ट होगा",
  top_up_credits_dialog_tip:
    "${0} प्रति क्रेडिट की दर से क्रेडिट खरीदें। अपनी आवश्यकताओं के आधार पर अपने क्रेडिट बंडल को अनुकूलित करें।",
  auto_top_up_notice_title: "ऑटो टॉप-अप नोटिस",
  not_now: "अभी नहीं",
  auto_top_up_para_1:
    "जब ऑटो टॉप-अप सक्षम होता है, तो एक बार जब आपका बैलेंस एक निर्धारित राशि से नीचे चला जाता है तो क्रेडिट स्वचालित रूप से जुड़ जाएंगे।",
  auto_top_up_para_2: "आपकी चयनित भुगतान विधि तदनुसार चार्ज की जाएगी",
  activate: "सक्रिय करें",
  assign: "आवंटित करें",
  ...sequence_hindi,

  ...notificationHindi,

  ...base,
  ...search,
  ...services,
  ...intent,
  ...tableEmptyInformationHindi,
  ...globalMessageHindi,
  ...settingApiKeysHindi,
  ...settings_pricing_hindi,
  ...home,
  ...premium,
  ...business,
  ...filter,
  ...popup,
  ...settings_role_team_hindi,
  ...settings_pricing_plan_hi,
  ...settings_profile_organization_hi,
  ...settings_users_hi,
  ...settings_custom_field_hindi,
  ...settings_billing_hindi,
  ...element,
  ...settings_redeem_code_hi,
  ...settings_plan_usage_hi,
  ...settings_referral_hi,
  ...monitors_hi,
  ...enrich_hi,
  ...welcome_tour_hi,
};
